import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "repayment-options-header-wrapper" }
const _hoisted_2 = { class: "repayment-options-header-sections" }
const _hoisted_3 = { class: "repayment-options-header-section repayment-option-payment-amounts-wrapper" }
const _hoisted_4 = { class: "payment-wrapper" }
const _hoisted_5 = { class: "payment-wrapper" }




export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentOptionsHeader',
  props: {
    inSchoolLabel: { default: "In-School" },
    postSchoolLabel: { default: "Post-Grad" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "repayment-options-header-section" }, "Repayment Type", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.inSchoolLabel), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.postSchoolLabel), 1)
      ])
    ])
  ]))
}
}

})